// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const Util = require('app/scripts/lib/util');

module.exports = window.IdCache = new (class {
  constructor() {
    this._shortLinkToId = {
      Card: {},
      Board: {},
    };
    this._idCardToIdBoard = {};
  }

  getId(typeName, id) {
    if (Util.checkId(id)) {
      return id;
    } else if (Util.isShortLink(id)) {
      return this._shortLinkToId[typeName][id];
    } else {
      throw new Error(`Not a shortLink or id: ${id}`);
    }
  }

  setId(typeName, shortLink, id) {
    if (!Util.checkId(id)) {
      throw new Error(`Not an id: ${id}`);
    }
    if (!Util.isShortLink(shortLink)) {
      throw new Error(`Not a shortLink: ${shortLink}`);
    }
    return (this._shortLinkToId[typeName][shortLink] = id);
  }

  setCardId(shortLink, id) {
    return this.setId('Card', shortLink, id);
  }

  setBoardId(shortLink, id) {
    return this.setId('Board', shortLink, id);
  }

  getCardId(id) {
    return this.getId('Card', id);
  }

  getBoardId(id) {
    return this.getId('Board', id);
  }
})();
